import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { class: "text-center q-mb-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message = _resolveComponent("message")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!

  return (_ctx.pendingReconnections > 0)
    ? (_openBlock(), _createBlock(_component_q_btn_dropdown, {
        key: 0,
        icon: "fa fa-clock",
        label: _ctx.pendingReconnections,
        color: "warning",
        rounded: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_message, { type: "warning" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.pendingReconnections) + " social account", 1),
                _withDirectives(_createElementVNode("span", null, "s", 512), [
                  [_vShow, _ctx.pendingReconnections > 1]
                ]),
                _createTextVNode(" are pending client action. ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_q_btn, {
              label: "View Social Accounts",
              to: `/social/customers/${this.accountId}/accounts/pending-reconnection`,
              color: "primary"
            }, null, 8, ["to"])
          ])
        ]),
        _: 1
      }, 8, ["label"]))
    : _createCommentVNode("", true)
}